import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteCourse, fetchCourseList } from "../actions/course";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";

const CourseList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { courseList } = useSelector((state) => state.courseReducer);

  //breadcrumb
  const translateModule = "course";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchCourseList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/course-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteCourse(pageId));
  };

  const columnDefs = [
    {
      headerName: "Kurs",
      field: "name",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Kanal",
      field: "channelName",
      filter: "agSetColumnFilter",
    },
    {
      headerName: "JWPlayer video",
      field: "trailerTargetId",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Cena",
      field: "price",
      filter: "agNumberColumnFilter",
      width: 140,
    },
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    {
      headerName: "Trajanje pristupa (dana)",
      field: "accessDuration",
      filter: "agNumberColumnFilter",
      width: 220,
    },
    {
      headerName: "Na prodaju",
      field: "shoppable",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Na popustu",
      field: "discount",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Besplatan",
      field: "free",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Cena sa popustom",
      field: "discountPrice",
      filter: "agNumberColumnFilter",
    },
    createDateColumn("Popust od", "discountStart"),
    createDateColumn("Popust do", "discountEnd"),
    createDateColumn("Datum kreiranja", "createdAt"),
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchCourseList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={courseList}
        columnDefs={columnDefs}
        buttonLink={`/course-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="course-list"
      />
    </Fragment>
  );
};

export default CourseList;
